import * as Sentry from "@sentry/react";

const dsn = String(process.env.REACT_APP_SENTRY_DSN || "").trim();

function sanitizeFrame(frame) {
  if (!frame || typeof frame !== "object") return frame;
  const sanitized = { ...frame };
  if (typeof sanitized.filename === "string") {
    sanitized.filename = sanitized.filename.split(/[?#]/, 1)[0];
  }
  delete sanitized.vars;
  return sanitized;
}

function scrubFrontendEvent(event) {
  const scrubbed = { ...event };

  delete scrubbed.breadcrumbs;
  delete scrubbed.contexts;
  delete scrubbed.extra;
  delete scrubbed.request;
  delete scrubbed.transaction;
  delete scrubbed.user;

  scrubbed.tags = {
    runtime: "browser",
    ...(process.env.REACT_APP_SENTRY_RELEASE
      ? { release_configured: "true" }
      : {}),
  };

  if (scrubbed.exception?.values) {
    scrubbed.exception = {
      ...scrubbed.exception,
      values: scrubbed.exception.values.map((value) => ({
        ...value,
        value: "CleanIQ frontend exception",
        stacktrace: value.stacktrace
          ? {
              ...value.stacktrace,
              frames: value.stacktrace.frames?.map(sanitizeFrame),
            }
          : undefined,
      })),
    };
  }

  return scrubbed;
}

Sentry.init({
  dsn: dsn || undefined,
  enabled: Boolean(dsn),
  environment:
    process.env.REACT_APP_SENTRY_ENVIRONMENT ||
    process.env.NODE_ENV ||
    "unknown",
  release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  sendDefaultPii: false,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  beforeBreadcrumb: () => null,
  beforeSend: scrubFrontendEvent,
  denyUrls: [
    /^chrome:\/\//i,
    /^safari-extension:\/\//i,
    /extensions\//i,
  ],
});

export function isFrontendSentryEnabled() {
  return Boolean(dsn);
}
